'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Item$PvpcontrollerWeb = require("../Item.js");
var Error$PvpcontrollerWeb = require("./Error.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Boolean$PvpcontrollerWeb = require("../Boolean.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Changelog$PvpcontrollerWeb = require("./Changelog.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var EntityList$PvpcontrollerWeb = require("./EntityList.js");
var ChangeModel$PvpcontrollerWeb = require("../models/ChangeModel.js");
var EditableValue$PvpcontrollerWeb = require("./EditableValue.js");
var SettingsService$PvpcontrollerWeb = require("../services/SettingsService.js");

var baseContent_0 = Css.padding2(Css.px(30), Css.px(50));

var baseContent_1 = {
  hd: Css.minHeight(Css.px(551)),
  tl: /* [] */0
};

var baseContent = {
  hd: baseContent_0,
  tl: baseContent_1
};

var content = Curry._1(Css.style, {
      hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
      tl: baseContent
    });

var contentLoading = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.backgroundColor(Css.hex("34373c")),
        tl: baseContent
      }
    });

var settingGroup = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent(Css.spaceBetween),
        tl: {
          hd: Css.marginBottom(Css.px(10)),
          tl: {
            hd: Css.child("div")({
                  hd: Css.width(Css.px(400)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var loneSettingGroup = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent(Css.spaceBetween),
        tl: {
          hd: Css.marginBottom(Css.px(10)),
          tl: {
            hd: Css.child("div")({
                  hd: Css.width({
                        NAME: "percent",
                        VAL: 100.0
                      }),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var settingGroupValues = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.width(Css.px(300)),
        tl: /* [] */0
      }
    });

var statEntry = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 50.0
          }),
      tl: {
        hd: Css.marginBottom(Css.px(10)),
        tl: /* [] */0
      }
    });

var h3 = Curry._1(Css.style, {
      hd: Css.color(Css.hex("99a2b3")),
      tl: /* [] */0
    });

function extractStateObject(state) {
  if (typeof state === "number") {
    return ;
  } else {
    return state._0;
  }
}

function settingsDetails(settings, editMode, stateHook, session, setChangelogState) {
  var damageDisableSeconds = String(settings.damageDisableSeconds);
  var banPrefixedArmor = Boolean$PvpcontrollerWeb.toHumanString(settings.banPrefixedArmor);
  var banTeleportItems = Boolean$PvpcontrollerWeb.toHumanString(settings.banTeleportItems);
  var potionHealAmount = String(settings.potionHealAmount);
  var potionHealCooldown = String(settings.potionHealCooldown);
  var preventImpossibleEquipment = Boolean$PvpcontrollerWeb.toHumanString(settings.preventImpossibleEquipment);
  var forceMaxHealth = Boolean$PvpcontrollerWeb.toHumanString(settings.forceMaxHealth);
  var neverRain = Boolean$PvpcontrollerWeb.toHumanString(settings.neverRain);
  var allowHookOfDissonance = Boolean$PvpcontrollerWeb.toHumanString(settings.allowHookOfDissonance);
  var correctPositionDesync = Boolean$PvpcontrollerWeb.toHumanString(settings.correctPositionDesync);
  var correctionMinDistance = settings.correctionMinDistance.toString();
  var defenseMultiplier = settings.defenseMultiplier.toString() + "%";
  var beetleArmorStage1 = settings.beetleArmorStages.weakStage.toString() + "%";
  var beetleArmorStage2 = settings.beetleArmorStages.middleStage.toString() + "%";
  var beetleArmorStage3 = settings.beetleArmorStages.strongStage.toString() + "%";
  var solarArmorStage1 = settings.solarArmorStages.weakStage.toString() + "%";
  var solarArmorStage2 = settings.solarArmorStages.middleStage.toString() + "%";
  var solarArmorStage3 = settings.solarArmorStages.strongStage.toString() + "%";
  var damageVariation = settings.damageVariation.toString() + "%";
  var time = ChangeModel$PvpcontrollerWeb.toTimeString(settings.time);
  var makeEditableValue = function (label, value, updateValue, onChange, tooltip, param) {
    return React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, tooltip, settings, session, editMode, label, value, onChange, updateValue, (function (param) {
                      return Curry._1(setChangelogState, (function (_previousState) {
                                    return /* Loading */0;
                                  }));
                    }), undefined, undefined));
  };
  var partial_arg = settings.damageDisableSeconds;
  var partial_arg$1 = settings.banPrefixedArmor;
  var partial_arg$2 = settings.banTeleportItems;
  var partial_arg$3 = settings.potionHealAmount;
  var partial_arg$4 = settings.potionHealCooldown;
  var partial_arg$5 = settings.preventImpossibleEquipment;
  var partial_arg$6 = settings.forceMaxHealth;
  var partial_arg$7 = settings.neverRain;
  var partial_arg$8 = settings.allowHookOfDissonance;
  var partial_arg$9 = settings.correctPositionDesync;
  var partial_arg$10 = settings.correctionMinDistance;
  var partial_arg$11 = settings.defenseMultiplier;
  var partial_arg$12 = settings.beetleArmorStages.weakStage;
  var partial_arg$13 = settings.beetleArmorStages.middleStage;
  var partial_arg$14 = settings.beetleArmorStages.strongStage;
  var partial_arg$15 = settings.solarArmorStages.weakStage;
  var partial_arg$16 = settings.solarArmorStages.middleStage;
  var partial_arg$17 = settings.solarArmorStages.strongStage;
  var partial_arg$18 = settings.damageVariation;
  var partial_arg$19 = settings.time;
  return React.createElement("div", {
              className: content
            }, React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Damage Disable Seconds", damageDisableSeconds, SettingsService$PvpcontrollerWeb.updateDamageDisableSeconds, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeIntValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: value,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg, param, param$1);
                      }), "The amount of time to ignore a player's damage when a player uses a banned weapon or projectile", undefined), makeEditableValue("Ban Prefixed Armor", banPrefixedArmor, SettingsService$PvpcontrollerWeb.updateBanPrefixedArmor, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: value,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$1, param, param$1);
                      }), undefined, undefined)), React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Ban Teleport Items", banTeleportItems, SettingsService$PvpcontrollerWeb.updateBanTeleportItems, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: value,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$2, param, param$1);
                      }), undefined, undefined), makeEditableValue("Potion Heal Amount", potionHealAmount, SettingsService$PvpcontrollerWeb.updatePotionHealAmount, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeIntValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: value,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$3, param, param$1);
                      }), undefined, undefined)), React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Potion Heal Cooldown", potionHealCooldown, SettingsService$PvpcontrollerWeb.updatePotionHealCooldown, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeIntValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: value,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$4, param, param$1);
                      }), undefined, undefined), makeEditableValue("Prevent Impossible Equipment", preventImpossibleEquipment, SettingsService$PvpcontrollerWeb.updatePreventImpossibleEquipment, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: value,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$5, param, param$1);
                      }), undefined, undefined)), React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Force Max Health", forceMaxHealth, SettingsService$PvpcontrollerWeb.updateForceMaxHealth, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: value,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$6, param, param$1);
                      }), undefined, undefined), makeEditableValue("Never Rain", neverRain, SettingsService$PvpcontrollerWeb.updateNeverRain, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: value,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$7, param, param$1);
                      }), undefined, undefined)), React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Allow Hook Of Dissonance", allowHookOfDissonance, SettingsService$PvpcontrollerWeb.updateAllowHookOfDissonance, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: value,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$8, param, param$1);
                      }), undefined, undefined), makeEditableValue("Correct Position Desync", correctPositionDesync, SettingsService$PvpcontrollerWeb.updateCorrectPositionDesync, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeBooleanValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: value,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$9, param, param$1);
                      }), undefined, undefined)), React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Correction Min Distance", correctionMinDistance, SettingsService$PvpcontrollerWeb.updateCorrectionMinDistance, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeIntValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: value,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$10, param, param$1);
                      }), undefined, undefined), makeEditableValue("Defense Multiplier", defenseMultiplier, SettingsService$PvpcontrollerWeb.updateDefenseMultiplier, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: value,
                                                damageVariation: object.damageVariation,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$11, param, param$1);
                      }), undefined, undefined)), React.createElement("div", {
                  className: settingGroup
                }, React.createElement("div", undefined, React.createElement("h3", {
                          className: h3
                        }, "Beetle Armor Stages"), React.createElement("div", {
                          className: settingGroupValues
                        }, makeEditableValue("1st", beetleArmorStage1, SettingsService$PvpcontrollerWeb.updateBeetleArmorStage1, (function (param, param$1) {
                                return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                              var init = object.beetleArmorStages;
                                              return /* Settings */{
                                                      _0: {
                                                        bannedEquipment: object.bannedEquipment,
                                                        damageDisableSeconds: object.damageDisableSeconds,
                                                        banTeleportItems: object.banTeleportItems,
                                                        banPrefixedArmor: object.banPrefixedArmor,
                                                        potionHealAmount: object.potionHealAmount,
                                                        potionHealCooldown: object.potionHealCooldown,
                                                        preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                        beetleArmorStages: {
                                                          weakStage: value,
                                                          middleStage: init.middleStage,
                                                          strongStage: init.strongStage
                                                        },
                                                        solarArmorStages: object.solarArmorStages,
                                                        forceMaxHealth: object.forceMaxHealth,
                                                        neverRain: object.neverRain,
                                                        allowHookOfDissonance: object.allowHookOfDissonance,
                                                        correctPositionDesync: object.correctPositionDesync,
                                                        correctionMinDistance: object.correctionMinDistance,
                                                        defenseMultiplier: object.defenseMultiplier,
                                                        damageVariation: object.damageVariation,
                                                        time: object.time
                                                      }
                                                    };
                                            }), partial_arg$12, param, param$1);
                              }), undefined, undefined), makeEditableValue("2nd", beetleArmorStage2, SettingsService$PvpcontrollerWeb.updateBeetleArmorStage2, (function (param, param$1) {
                                return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                              var init = object.beetleArmorStages;
                                              return /* Settings */{
                                                      _0: {
                                                        bannedEquipment: object.bannedEquipment,
                                                        damageDisableSeconds: object.damageDisableSeconds,
                                                        banTeleportItems: object.banTeleportItems,
                                                        banPrefixedArmor: object.banPrefixedArmor,
                                                        potionHealAmount: object.potionHealAmount,
                                                        potionHealCooldown: object.potionHealCooldown,
                                                        preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                        beetleArmorStages: {
                                                          weakStage: init.weakStage,
                                                          middleStage: value,
                                                          strongStage: init.strongStage
                                                        },
                                                        solarArmorStages: object.solarArmorStages,
                                                        forceMaxHealth: object.forceMaxHealth,
                                                        neverRain: object.neverRain,
                                                        allowHookOfDissonance: object.allowHookOfDissonance,
                                                        correctPositionDesync: object.correctPositionDesync,
                                                        correctionMinDistance: object.correctionMinDistance,
                                                        defenseMultiplier: object.defenseMultiplier,
                                                        damageVariation: object.damageVariation,
                                                        time: object.time
                                                      }
                                                    };
                                            }), partial_arg$13, param, param$1);
                              }), undefined, undefined), makeEditableValue("3rd", beetleArmorStage3, SettingsService$PvpcontrollerWeb.updateBeetleArmorStage3, (function (param, param$1) {
                                return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                              var init = object.beetleArmorStages;
                                              return /* Settings */{
                                                      _0: {
                                                        bannedEquipment: object.bannedEquipment,
                                                        damageDisableSeconds: object.damageDisableSeconds,
                                                        banTeleportItems: object.banTeleportItems,
                                                        banPrefixedArmor: object.banPrefixedArmor,
                                                        potionHealAmount: object.potionHealAmount,
                                                        potionHealCooldown: object.potionHealCooldown,
                                                        preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                        beetleArmorStages: {
                                                          weakStage: init.weakStage,
                                                          middleStage: init.middleStage,
                                                          strongStage: value
                                                        },
                                                        solarArmorStages: object.solarArmorStages,
                                                        forceMaxHealth: object.forceMaxHealth,
                                                        neverRain: object.neverRain,
                                                        allowHookOfDissonance: object.allowHookOfDissonance,
                                                        correctPositionDesync: object.correctPositionDesync,
                                                        correctionMinDistance: object.correctionMinDistance,
                                                        defenseMultiplier: object.defenseMultiplier,
                                                        damageVariation: object.damageVariation,
                                                        time: object.time
                                                      }
                                                    };
                                            }), partial_arg$14, param, param$1);
                              }), undefined, undefined))), React.createElement("div", undefined, React.createElement("h3", {
                          className: h3
                        }, "Solar Armor Stages"), React.createElement("div", {
                          className: settingGroupValues
                        }, makeEditableValue("1st", solarArmorStage1, SettingsService$PvpcontrollerWeb.updateSolarArmorStage1, (function (param, param$1) {
                                return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                              var init = object.solarArmorStages;
                                              return /* Settings */{
                                                      _0: {
                                                        bannedEquipment: object.bannedEquipment,
                                                        damageDisableSeconds: object.damageDisableSeconds,
                                                        banTeleportItems: object.banTeleportItems,
                                                        banPrefixedArmor: object.banPrefixedArmor,
                                                        potionHealAmount: object.potionHealAmount,
                                                        potionHealCooldown: object.potionHealCooldown,
                                                        preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                        beetleArmorStages: object.beetleArmorStages,
                                                        solarArmorStages: {
                                                          weakStage: value,
                                                          middleStage: init.middleStage,
                                                          strongStage: init.strongStage
                                                        },
                                                        forceMaxHealth: object.forceMaxHealth,
                                                        neverRain: object.neverRain,
                                                        allowHookOfDissonance: object.allowHookOfDissonance,
                                                        correctPositionDesync: object.correctPositionDesync,
                                                        correctionMinDistance: object.correctionMinDistance,
                                                        defenseMultiplier: object.defenseMultiplier,
                                                        damageVariation: object.damageVariation,
                                                        time: object.time
                                                      }
                                                    };
                                            }), partial_arg$15, param, param$1);
                              }), undefined, undefined), makeEditableValue("2nd", solarArmorStage2, SettingsService$PvpcontrollerWeb.updateSolarArmorStage2, (function (param, param$1) {
                                return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                              var init = object.solarArmorStages;
                                              return /* Settings */{
                                                      _0: {
                                                        bannedEquipment: object.bannedEquipment,
                                                        damageDisableSeconds: object.damageDisableSeconds,
                                                        banTeleportItems: object.banTeleportItems,
                                                        banPrefixedArmor: object.banPrefixedArmor,
                                                        potionHealAmount: object.potionHealAmount,
                                                        potionHealCooldown: object.potionHealCooldown,
                                                        preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                        beetleArmorStages: object.beetleArmorStages,
                                                        solarArmorStages: {
                                                          weakStage: init.weakStage,
                                                          middleStage: value,
                                                          strongStage: init.strongStage
                                                        },
                                                        forceMaxHealth: object.forceMaxHealth,
                                                        neverRain: object.neverRain,
                                                        allowHookOfDissonance: object.allowHookOfDissonance,
                                                        correctPositionDesync: object.correctPositionDesync,
                                                        correctionMinDistance: object.correctionMinDistance,
                                                        defenseMultiplier: object.defenseMultiplier,
                                                        damageVariation: object.damageVariation,
                                                        time: object.time
                                                      }
                                                    };
                                            }), partial_arg$16, param, param$1);
                              }), undefined, undefined), makeEditableValue("3rd", solarArmorStage3, SettingsService$PvpcontrollerWeb.updateSolarArmorStage3, (function (param, param$1) {
                                return EditableValue$PvpcontrollerWeb.onChangeIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                              var init = object.solarArmorStages;
                                              return /* Settings */{
                                                      _0: {
                                                        bannedEquipment: object.bannedEquipment,
                                                        damageDisableSeconds: object.damageDisableSeconds,
                                                        banTeleportItems: object.banTeleportItems,
                                                        banPrefixedArmor: object.banPrefixedArmor,
                                                        potionHealAmount: object.potionHealAmount,
                                                        potionHealCooldown: object.potionHealCooldown,
                                                        preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                        beetleArmorStages: object.beetleArmorStages,
                                                        solarArmorStages: {
                                                          weakStage: init.weakStage,
                                                          middleStage: init.middleStage,
                                                          strongStage: value
                                                        },
                                                        forceMaxHealth: object.forceMaxHealth,
                                                        neverRain: object.neverRain,
                                                        allowHookOfDissonance: object.allowHookOfDissonance,
                                                        correctPositionDesync: object.correctPositionDesync,
                                                        correctionMinDistance: object.correctionMinDistance,
                                                        defenseMultiplier: object.defenseMultiplier,
                                                        damageVariation: object.damageVariation,
                                                        time: object.time
                                                      }
                                                    };
                                            }), partial_arg$17, param, param$1);
                              }), undefined, undefined)))), React.createElement("div", {
                  className: settingGroup
                }, makeEditableValue("Damage Variation", damageVariation, SettingsService$PvpcontrollerWeb.updateDamageVariation, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangeUnsignedIntPercentValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: value,
                                                time: object.time
                                              }
                                            };
                                    }), partial_arg$18, param, param$1);
                      }), "When damage is calculated, it is then randomised to somewhere between [damage - (damage * damageVariation), damage + (damage * damageVariation)] ", undefined), makeEditableValue("Time", time, SettingsService$PvpcontrollerWeb.updateTime, (function (param, param$1) {
                        return EditableValue$PvpcontrollerWeb.onChangedTimeValue(stateHook, extractStateObject, (function (object, value) {
                                      return /* Settings */{
                                              _0: {
                                                bannedEquipment: object.bannedEquipment,
                                                damageDisableSeconds: object.damageDisableSeconds,
                                                banTeleportItems: object.banTeleportItems,
                                                banPrefixedArmor: object.banPrefixedArmor,
                                                potionHealAmount: object.potionHealAmount,
                                                potionHealCooldown: object.potionHealCooldown,
                                                preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                beetleArmorStages: object.beetleArmorStages,
                                                solarArmorStages: object.solarArmorStages,
                                                forceMaxHealth: object.forceMaxHealth,
                                                neverRain: object.neverRain,
                                                allowHookOfDissonance: object.allowHookOfDissonance,
                                                correctPositionDesync: object.correctPositionDesync,
                                                correctionMinDistance: object.correctionMinDistance,
                                                defenseMultiplier: object.defenseMultiplier,
                                                damageVariation: object.damageVariation,
                                                time: value
                                              }
                                            };
                                    }), partial_arg$19, param, param$1);
                      }), "The time that the server will keep to.", undefined)), React.createElement("div", {
                  className: loneSettingGroup
                }, React.createElement(EntityList$PvpcontrollerWeb.make, EntityList$PvpcontrollerWeb.makeProps(settings.bannedEquipment, "Banned Equipment", editMode, (function (param, param$1) {
                            return EntityList$PvpcontrollerWeb.onNewValue(stateHook, extractStateObject, (function (object, value) {
                                          return /* Settings */{
                                                  _0: {
                                                    bannedEquipment: object.bannedEquipment.concat([value]),
                                                    damageDisableSeconds: object.damageDisableSeconds,
                                                    banTeleportItems: object.banTeleportItems,
                                                    banPrefixedArmor: object.banPrefixedArmor,
                                                    potionHealAmount: object.potionHealAmount,
                                                    potionHealCooldown: object.potionHealCooldown,
                                                    preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                    beetleArmorStages: object.beetleArmorStages,
                                                    solarArmorStages: object.solarArmorStages,
                                                    forceMaxHealth: object.forceMaxHealth,
                                                    neverRain: object.neverRain,
                                                    allowHookOfDissonance: object.allowHookOfDissonance,
                                                    correctPositionDesync: object.correctPositionDesync,
                                                    correctionMinDistance: object.correctionMinDistance,
                                                    defenseMultiplier: object.defenseMultiplier,
                                                    damageVariation: object.damageVariation,
                                                    time: object.time
                                                  }
                                                };
                                        }), (function (input) {
                                          var number = Belt_Int.fromString(input);
                                          if (number !== undefined) {
                                            return number;
                                          }
                                          var search = input.toLowerCase();
                                          var found = Item$PvpcontrollerWeb.items.findIndex(function (item) {
                                                return item.toLowerCase() === search;
                                              });
                                          if (found >= 0) {
                                            return found;
                                          }
                                          var partialMatches = Belt_Array.keepMap(Belt_Array.mapWithIndex(Item$PvpcontrollerWeb.items, (function (i, item) {
                                                      return [
                                                              i,
                                                              item
                                                            ];
                                                    })), (function (param) {
                                                  if (param[1].toLowerCase().startsWith(search)) {
                                                    return param[0];
                                                  }
                                                  
                                                }));
                                          if (partialMatches.length === 1) {
                                            return Caml_array.get(partialMatches, 0);
                                          }
                                          
                                        }), param, param$1);
                          }), SettingsService$PvpcontrollerWeb.addBannedEquipment, SettingsService$PvpcontrollerWeb.removeBannedEquipment, session, (function (netId) {
                            return Caml_array.get(Item$PvpcontrollerWeb.items, netId);
                          }), (function (param, param$1, param$2) {
                            return EntityList$PvpcontrollerWeb.onRemoveEntity(stateHook, extractStateObject, (function (object, value) {
                                          return /* Settings */{
                                                  _0: {
                                                    bannedEquipment: object.bannedEquipment.filter(function (entity) {
                                                          return entity !== value;
                                                        }),
                                                    damageDisableSeconds: object.damageDisableSeconds,
                                                    banTeleportItems: object.banTeleportItems,
                                                    banPrefixedArmor: object.banPrefixedArmor,
                                                    potionHealAmount: object.potionHealAmount,
                                                    potionHealCooldown: object.potionHealCooldown,
                                                    preventImpossibleEquipment: object.preventImpossibleEquipment,
                                                    beetleArmorStages: object.beetleArmorStages,
                                                    solarArmorStages: object.solarArmorStages,
                                                    forceMaxHealth: object.forceMaxHealth,
                                                    neverRain: object.neverRain,
                                                    allowHookOfDissonance: object.allowHookOfDissonance,
                                                    correctPositionDesync: object.correctPositionDesync,
                                                    correctionMinDistance: object.correctionMinDistance,
                                                    defenseMultiplier: object.defenseMultiplier,
                                                    damageVariation: object.damageVariation,
                                                    time: object.time
                                                  }
                                                };
                                        }), param, param$1, param$2);
                          }), (function (param) {
                            return Curry._1(setChangelogState, (function (_previousState) {
                                          return /* Loading */0;
                                        }));
                          }), (function (netId) {
                            return ChangeModel$PvpcontrollerWeb.imageUrl + "/" + ChangeModel$PvpcontrollerWeb.toImageName(Caml_array.get(Item$PvpcontrollerWeb.items, netId)) + ".png";
                          }), undefined, undefined))));
}

function Settings(Props) {
  var editMode = Props.editMode;
  var session = Props.session;
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return /* Loading */0;
      });
  var setChangelogState = match$1[1];
  React.useEffect((function () {
          return SettingsService$PvpcontrollerWeb.getSettings(function (settings) {
                      if (settings.TAG === /* Ok */0) {
                        var settings$1 = settings._0;
                        return Curry._1(setState, (function (_previousState) {
                                      return /* Settings */{
                                              _0: settings$1
                                            };
                                    }));
                      }
                      var err = settings._0;
                      if (err.RE_EXN_ID === "Match_failure") {
                        var match = err._1;
                        Debugging$PvpcontrollerWeb.messageWithData("Settings-PvpcontrollerWeb" + (":getSettings Could not destructure settings. Failed at " + match[0] + ":L" + match[1].toString() + "_C" + match[2].toString()), {
                              tags: (function (prim) {
                                  return {};
                                }),
                              extra: err
                            });
                      } else {
                        Debugging$PvpcontrollerWeb.messageWithData("Settings-PvpcontrollerWeb:getSettings Could not get settings.", {
                              tags: (function (prim) {
                                  return {};
                                }),
                              extra: err
                            });
                      }
                      return Curry._1(setState, (function (_previousState) {
                                    return /* LoadingFailed */1;
                                  }));
                    });
        }), []);
  var stateHook = [
    state,
    setState
  ];
  return React.createElement("div", {
              className: Theme$PvpcontrollerWeb.limitedWidthCard
            }, React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Settings"), typeof state === "number" ? (
                state !== 0 ? React.createElement(Error$PvpcontrollerWeb.make, Error$PvpcontrollerWeb.makeProps(undefined, undefined)) : React.createElement("div", {
                        className: contentLoading
                      }, React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)))
              ) : settingsDetails(state._0, editMode, stateHook, session, setChangelogState), React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Changelog"), React.createElement(Changelog$PvpcontrollerWeb.make, Changelog$PvpcontrollerWeb.makeProps(SettingsService$PvpcontrollerWeb.getChangelog, false, match$1[0], setChangelogState, undefined, undefined, undefined, undefined, undefined)));
}

function makeProps(prim0, prim1, prim2, prim3) {
  var tmp = {
    editMode: prim0,
    session: prim1
  };
  if (prim2 !== undefined) {
    tmp.key = prim2;
  }
  return tmp;
}

var make = Settings;

exports.makeProps = makeProps;
exports.make = make;
/* baseContent Not a pure module */
